import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, CircularProgress, Collapse, Divider, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';

export default function ContactPortfolioSectionCard({
  title,
  icon,
  loading: sectionLoading,
  children,
  defaultExpanded = true,
  action,
}: {
  title: string;
  icon: React.ReactNode;
  loading?: boolean;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  action?: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultExpanded);
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden', mb: 2.5 }}>
      <Box
        onClick={() => setOpen((v) => !v)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 1.5,
          cursor: 'pointer',
          '&:hover': { bgcolor: 'action.hover' },
          userSelect: 'none',
        }}
      >
        {icon}
        <Typography variant="subtitle1" fontWeight={600} sx={{ flex: 1 }}>
          {title}
        </Typography>
        {sectionLoading && <CircularProgress size={16} sx={{ mr: 1 }} />}
        {action && <Box onClick={(e) => e.stopPropagation()}>{action}</Box>}
        <ExpandMoreIcon
          sx={{
            fontSize: 20,
            color: 'text.secondary',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s',
          }}
        />
      </Box>
      <Collapse in={open}>
        <Divider />
        <Box sx={{ p: 2 }}>{children}</Box>
      </Collapse>
    </Paper>
  );
}
